import { useTranslation } from 'react-i18next';
import CancelTargetInfo from '@/components/Approval/@components/CancelTargetInfo';
import type { CancelApprovalAttributes } from '@/types/approval';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 근태 취소 품의 6종 — 취소 대상 원 품의는 attributes 로 옴(별도 조회 없음) */
const CancelTargetSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  // attributes 가 비어도 박스는 그림('-') — 레거시 조회 폼과 동일
  const target = (data.attributes ?? {}) as Partial<CancelApprovalAttributes>;

  return (
    <ContentSlotRoot>
      <CancelTargetInfo title={t('취소할 품의')} target={target} />
    </ContentSlotRoot>
  );
};

export default CancelTargetSlot;
